<div class="app-container" *ngIf="loading">
  <mat-progress-spinner  mode="indeterminate"></mat-progress-spinner>
</div>

<router-outlet />

